export default { sha: 'a59ac07c4823d0ef86c00a37354872effe848ec1', buildNumber: 'undefined' }
